module.exports = __webpack_public_path__ + "static/media/Team 20 - Orcas 2020.747962b5.png";